  //数字转大写
  export function toChies(money){
    // if(!money){
    //   money = 0
    // }
    // money = (+money).toFixed(2)
    // let moneymax = money.split('.')[0]
    // let moneymin = money.split('.')[1]
    // let len =moneymax.length//统计出长度
    // let arr=[];
    // let str2 = ''
    // let chin_list=['零','壹','贰','叁','肆','伍','陆','柒','捌','玖']
    // let chin_lisp=['仟','佰','拾','亿','仟','佰','拾','万','仟','佰','拾']
  
    // for(let i=0;i<len;i++){
    //   arr.push(parseInt(money[i]));
    //   arr[i]=chin_list[arr[i]]
    // }
    // for(let i=len-1,j=1;i>0;i--){
    //   arr.splice(i,0,chin_lisp[chin_lisp.length-j++])
    // }
    // for (var i = 0; i < moneymin.length; i++) {
    //   str2 += chin_list[moneymin[i]];
    // }
    // str2 = str2[0] +'角' +str2[1] + '分'
    // arr=arr.join('')
    // arr+='元'
    // return arr + str2

    var cnMoney = "零元整";
    var strOutput = "";
    var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    money += "00";
    var intPos = money.indexOf('.');
    if (intPos >= 0) {
       money = money.substring(0, intPos) + money.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - money.length);
    for (var i = 0; i < money.length; i++) {
       strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(money.substr(i, 1), 1) + strUnit.substr(i, 1);
    }
    cnMoney = strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
    return cnMoney;
  }
  
  
